import React, { useEffect, useState } from "react";

const EXPECTED = { image: 35, video: 90 };
const STAGES = {
  image: [{ id: "scene", label: "تجهيز المشهد" }, { id: "finishing", label: "إضافة الهوية واللمسات" }],
  video: [{ id: "scene", label: "تجهيز المشهد" }, { id: "animate", label: "تحريك اللقطات" }, { id: "stitch", label: "دمج اللقطات والصوت" }, { id: "finishing", label: "إضافة الهوية" }],
};

const fmt = (s) => (s >= 60 ? `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")} دقيقة` : `${s} ثانية`);

export function GenProgress({ kind = "image", job, compact = false }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => { const t = setInterval(() => setNow(Date.now()), 1000); return () => clearInterval(t); }, []);
  const start = job?.start || now;
  const elapsed = Math.max(0, Math.round((now - start) / 1000));
  const expected = EXPECTED[kind];
  const timePct = Math.min(90, (elapsed / expected) * 90);
  const pct = Math.round(Math.min(99, Math.max(job?.progress || 0, timePct, 3)));
  const byRate = pct > 15 ? (elapsed * (100 - pct)) / pct : expected - elapsed;
  const remaining = Math.max(5, Math.round(Math.max(byRate, expected - elapsed)));
  const overdue = elapsed > expected * 1.3;
  const stages = STAGES[kind];
  const stage = job?.stage || "scene";
  const sIdx = Math.max(0, stages.findIndex((s) => s.id === stage));

  if (stage === "queued") {
    return (
      <div className={`w-full ${compact ? "mt-2" : "max-w-sm mx-auto text-center"}`} data-testid={`gen-progress-${kind}-queued`}>
        <div className="rounded-xl border border-accent/40 bg-accent/10 px-4 py-3 text-sm">
          <div className="font-bold text-accent">طلبك في طابور التوليد</div>
          <div className="text-muted-foreground mt-1">ترتيبك: <b className="text-foreground" data-testid="queue-position">{job?.queue_position || 1}</b> — يبدأ التوليد تلقائيًا عند دورك، لا تغلق الصفحة أو عد لاحقًا من مكتبة المحتوى</div>
        </div>
        <div className="h-2.5 rounded-full bg-secondary overflow-hidden border border-border mt-3">
          <div className="h-full w-[3%] rounded-full bg-accent/60 animate-pulse" />
        </div>
      </div>
    );
  }

  return (
    <div className={`w-full ${compact ? "mt-2" : "max-w-sm mx-auto text-center"}`} data-testid={`gen-progress-${kind}`}>
      {!compact && (
        <div className="flex justify-center gap-2 mb-3 flex-wrap">
          {stages.map((s, i) => (
            <span key={s.id} className={`text-[11px] px-2.5 py-1 rounded-full border transition-colors ${i < sIdx ? "border-primary/40 text-primary" : i === sIdx ? "border-accent bg-accent/10 text-accent font-bold" : "border-border text-muted-foreground"}`}>
              {i + 1}. {s.label}
            </span>
          ))}
        </div>
      )}
      <div className="h-2.5 rounded-full bg-secondary overflow-hidden border border-border">
        <div className="h-full rounded-full bg-gradient-to-l from-accent to-primary transition-[width] duration-700 ease-out" style={{ width: `${pct}%` }} />
      </div>
      <div className="flex justify-between text-[11px] text-muted-foreground mt-1.5">
        <span data-testid="gen-progress-percent" className="font-bold text-foreground">{pct}%</span>
        <span>{compact ? `${stages[sIdx].label} · ` : ""}{overdue ? <span data-testid="gen-progress-eta">يستغرق وقتاً أطول من المعتاد… ({fmt(elapsed)})</span> : <>المتبقي تقريباً: <span data-testid="gen-progress-eta">{fmt(remaining)}</span></>}</span>
      </div>
    </div>
  );
}
